<template>
  <div class="container g-flex g-row-center">
    <div class="total-width border-top">
      <div class="g-flex g-row-between g-p-t-15 g-p-b-15">
        <div class="g-flex">
          <p class="g-font-16 g-nowrap">是否精品课程：</p>
          <div class="select-list g-m-l-10">
            <el-select v-model="value1" @change="change1" placeholder="请选择" clearable>
              <el-option
                  v-for="(item, index) in selectList"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="g-flex">
          <p class="g-font-16 g-nowrap">是否付费：</p>
          <div class="select-list g-m-l-10">
            <el-select v-model="value2" @change="change2" placeholder="请选择" clearable>
              <el-option
                  v-for="(item, index) in selectList2"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="g-flex">
          <p class="g-font-16 g-nowrap">热度排序：</p>
          <div class="select-list g-m-l-10">
            <el-select v-model="value3" @change="change3" placeholder="请选择" clearable>
              <el-option
                  v-for="(item, index) in selectList3"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="g-flex">
          <p class="g-font-16 g-nowrap">价格排序：</p>
          <div class="select-list g-m-l-10">
            <el-select v-model="value4" @change="change4" placeholder="请选择" clearable>
              <el-option
                  v-for="(item, index) in selectList4"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filters",
  data(){
    return{
      selectList: [
        {
          name: '不限',
          value: null
        },
        {
          name: '是',
          value: true
        },
        {
          name: '否',
          value: false
        }
      ],
      value1:'',
      selectList2: [
        {
          name: '不限',
          value: null
        },
        {
          name: '是',
          value: true
        },
        {
          name: '否',
          value: false
        }
      ],
      value2:'',
      selectList3: [
        {
          name: '不限',
          value: null
        },
        {
          name: '从高到低',
          value: 'desc'
        },
        {
          name: '从低到高',
          value: 'asc'
        }
      ],
      value3:'',
      selectList4: [
        {
          name: '不限',
          value: null
        },
        {
          name: '从高到低',
          value: 'desc'
        },
        {
          name: '从低到高',
          value: 'asc'
        }
      ],
      value4:'',//价格排序
    }
  },
  methods:{
    // 我的课程选择回调
    change1(v){
      this.value1 = v
      this.$emit('change1', this.value1)
    },
    // 是否付费选择回调
    change2(v){
      this.value2 = v
      this.$emit('change2', this.value2)
    },
    // 热度排序选择回调
    change3(v){
      this.value3 = v
      this.$emit('change3', this.value3)
    },
    // 价格排序选择回调
    change4(v){
      this.value4 = v
      this.$emit('change4', this.value4)
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    background: #fff;
  }

  .border-top{
    border-top: 1px solid #f7f7f7;
  }

  ::v-deep .el-select{
    width: 180px;
    background: #f6f6f8!important;
    border-radius: 5px;
    border: none;
  }

  ::v-deep .el-input--suffix .el-input__inner{
    background: #f6f6f8;
    border-radius: 5px;
    border: none;
  }
</style>
